import React from 'react'
import { TableBodyRow, TableHead } from '../../../../../widget/styledComponents/table.style';
import { Badge, Dialog, IconButton, MoreIcon, Pagination, Pane, Spinner, toaster } from 'evergreen-ui';
import { FieldBtn, GuestListTableContainer } from '../../dues/dues.style';
import { gql, useMutation, useQuery } from '@apollo/client';
import { useState } from 'react';
import Cookies from 'js-cookie';
import {  DetailsTabsT, FlexyRow } from '../property.style';
import { AppInputField, AppInputFieldBtn, AppInputFieldBtnCancel, InputFieldTitleText } from '../../../../../widget/styledComponents/input_field.style';
import DropdownWidget from '../../../../../widget/dropdown';
import DropdownWidget2 from '../../../../../widget/dropdown2';
// import DropdownWidget3 from '../../../../../widget/dropdown2';
import { capitalizeFirstLetterOfWords } from '../../../../../widget/util';
import SelectDue from './listBillsDropDown';
import ReceivablesDetails from './receivablesDetails';

export const FETCH_RECEIVABLES_LIST = gql`
query Receivables_getByProperty($propertyId: ID!) {
  receivables_getByProperty(propertyId: $propertyId) {
    _id
    property
    amount
    description
    appliesToBills
    bills
    receivedFrom
    receivedFromType
    receivedOn
    reference
    createdAt
    id
  }
}
`;


export default function Receivables(props) {
  const data = props.details
  const pages =[
    {
      title:"All",
      widget:<PropertyPageWidget data={data}/>
    },
    {
      title:"Bill Receivables",
      widget:<PropertyPageWidgetBillReceivabes data={data}/>
    },
    {
      title:"Non-Bill Receivables",
      widget:<PropertyPageWidgetNonBillReceivabes data={data}/>

    }
  ];
  const [selected,setSelected] = useState(0)
  return (
    <div>
      <FlexyRow>
        {pages.map((itm,i)=>
          <DetailsTabsT className=''
            onClick={()=>setSelected(i)}
          >
            <span className={selected===i?'active':''}>
              {itm.title}
            </span>
          </DetailsTabsT>
          )
        }
      </FlexyRow>
      {pages[selected].widget}  
    </div>
  )
}




function PropertyPageWidget(props) {
  const property = props.data
  const { loading,data }  = useQuery(FETCH_RECEIVABLES_LIST,{
      variables: {
        propertyId:property._id,
      },
  });
  const [receivableDetails,
    setReceivableDetails
] = useState(null)
  const [receivableDetailsOn,
    setReceivableDetailsOn
] = useState(false)


    return (
      <div>
      
  
       {receivableDetailsOn
        ?<div>
            <ReceivablesDetails data={receivableDetails} />
            <button className='btn btn-flat grey lighten-4'
                type='button'
                onClick={()=>{
                  setReceivableDetailsOn(false)
                  setReceivableDetails(null)
                }}
            >
                Close
            </button>
          </div>
        :
        <div className=''>
            <br/>
            <GuestListTableContainer>
               
                <table className='responsive-table'>
                    <thead>
                    <tr
                    >
                        <TableHead>Description</TableHead>
                        <TableHead>Amount</TableHead>
                        <TableHead>Date of payment</TableHead>
                        <TableHead>
                          Status
                        </TableHead>

                        <TableHead>
                          <MoreIcon />
                        </TableHead>
  
                    </tr>
                    </thead>
  
                    <tbody>
                        {loading && <Spinner/> }
                        {data &&
                        
                        data.receivables_getByProperty.map((data) => 
                          
                            <TableBodyRow
                                onClick={()=>{
                                  setReceivableDetailsOn(true)
                                  setReceivableDetails(data)
                                }
                              }
                            >
                                <td>{capitalizeFirstLetterOfWords(data.description)}</td>
                                <td>N{data.amount}</td>
                                <td>{data.createdAt}</td>
                                <td>
                                  <Badge color="purple">{data.appliesToBills?"Bill Receivable":"Non-bill Receivable"}</Badge>
                                </td>
                                <td>
                                  <IconButton
                                     onClick={()=>{
                                    }}
                                  icon={MoreIcon} intent="primary"  />
                                  
                                </td>
                              
                            </TableBodyRow>
                            )
                        }
                      
                    </tbody>
                </table>
                <Pagination className='transparent z-depth-0' 
                totalPages={4} 
                 
                ></Pagination>             
            </GuestListTableContainer>

            <br/>
            <center>
             <AddReceivables property={property}/>
            </center>
        </div>
        }
      </div>
    )
}
  

function PropertyPageWidgetBillReceivabes(props) {
  const property = props.data
  const { loading,data }  = useQuery(FETCH_RECEIVABLES_LIST,{
      variables: {
        propertyId:property._id,
      },
  });
  const [receivableDetails,
    // setReceivableDetails
] = useState(null)
  const [receivableDetailsOn,
    // setReceivableDetailsOn
] = useState(false)

    return (
      <div>
      
  
       {receivableDetailsOn
        ?<ReceivablesDetails data={receivableDetails} />
        :
        <div className=''>
            <br/>
            <GuestListTableContainer>
               
                <table className='responsive-table'>
                    <thead>
                    <tr
                    >
                        <TableHead>Title</TableHead>
                        <TableHead>Amount</TableHead>
                        <TableHead>Date of payment</TableHead>
                        <TableHead>
                          Status
                        </TableHead>
                        <TableHead>
                          <MoreIcon />
                        </TableHead>
  
                    </tr>
                    </thead>
  
                    <tbody>
                        {loading && <Spinner/> }
                        {data &&
                        
                        data.receivables_getByProperty.map((data) => 
                          !data.appliesToBills
                          ?null 
                          :
                          <TableBodyRow
                                // onClick={()=>{
                                //   setReceivableDetailsOn(true)
                                //   setReceivableDetails(data)
                                // }
                              // }
                            >
                                <td>{capitalizeFirstLetterOfWords(data.description)}</td>
                                <td>N{data.amount}</td>
                                <td>{data.createdAt}</td>
                                <td>
                                  <Badge color="purple">{data.appliesToBills?"Bill Receivable":"Non-bill Receivable"}</Badge>
                                </td>
                                <td>
                                  <IconButton
                                     onClick={()=>{
                                    }}
                                  icon={MoreIcon} intent="primary"  />
                                  
                                </td>
                              
                            </TableBodyRow>
                          
                            )
                        }
                      
                    </tbody>
                </table>
                <Pagination className='transparent z-depth-0' 
                totalPages={4} 
                 
                ></Pagination>             
            </GuestListTableContainer>

            <br/>
            <center>
             <AddReceivables property={property}/>
            </center>
        </div>
        }
      </div>
    )
}
  


function PropertyPageWidgetNonBillReceivabes(props) {
  const property = props.data
  const { loading,data }  = useQuery(FETCH_RECEIVABLES_LIST,{
      variables: {
        propertyId:property._id,
      },
  });
  const [receivableDetails,
    // setReceivableDetails
] = useState(null)
  const [receivableDetailsOn,
    // setReceivableDetailsOn
] = useState(false)
    return (
      <div>
        {receivableDetailsOn
        ?<ReceivablesDetails data={receivableDetails} />
        :<div className=''>
            <br/>
            <GuestListTableContainer>
               
                <table className='responsive-table'>
                    <thead>
                    <tr
                    >
                        <TableHead>Title</TableHead>
                        <TableHead>Amount</TableHead>
                        <TableHead>Date of payment</TableHead>
                        <TableHead>
                          Status
                        </TableHead>
                        <TableHead>
                          <MoreIcon />
                        </TableHead>
  
                    </tr>
                    </thead>
  
                    <tbody>
                        {loading && <Spinner/> }
                        {data &&
                        
                        data.receivables_getByProperty.map((data) => 
                            data.appliesToBills
                            ?null 
                            :<TableBodyRow
                            //   onClick={()=>{
                            //     setReceivableDetailsOn(true)
                            //     setReceivableDetails(data)
                            //   }
                            // }  
                            >
                                <td>{capitalizeFirstLetterOfWords(data.description)}</td>
                                <td>N{data.amount}</td>
                                <td>{data.createdAt}</td>
                                <td>
                                  <Badge color="purple">{data.appliesToBills?"Bill Receivable":"Non-bill Receivable"}</Badge>
                                </td>
                                <td>
                                  <IconButton
                                     onClick={()=>{
                                    }}
                                  icon={MoreIcon} intent="primary"  />
                                  
                                </td>
                              
                            </TableBodyRow>
                            
                            )
                        }
                      
                    </tbody>
                </table>
                <Pagination className='transparent z-depth-0' 
                totalPages={4} 
                 
                ></Pagination>             
            </GuestListTableContainer>

            <br/>
            <center>
             <AddReceivables property={property}/>
            </center>
        </div>
        }
      </div>
    )
}



export const ADD_RECEIVABLES = gql`
mutation Receivable_create($propertyId: ID!, $appliesToBills: Boolean!, $amount: Float!, $billIds: [ID!]!, $receivedOn: Date!, $receivedFromType: ReceivableReceivedFromType!, $description: String) {
  receivable_create(propertyId: $propertyId, appliesToBills: $appliesToBills, amount: $amount, billIds: $billIds, receivedOn: $receivedOn, receivedFromType: $receivedFromType, description: $description) {
    _id
    amount
    appliesToBills
  }
}
`;


function AddReceivables(props) {
  const property = props.property
  const accesTokenValue = Cookies.get('userAccessToken');
  const [addReceivables, { loading }] = useMutation(ADD_RECEIVABLES);
const [checked, setChecked] = React.useState(false)

  const [isShown, setIsShown] = React.useState(false)
  const [dataObject, setDataObject] = useState({
    propertyId: property._id,
    appliesToBills:false,
    billIds:[]
  });
 
  
  const handleSubmit=(e)=>{
    e.preventDefault()
  
  
    console.log(dataObject)
    
    addReceivables({
      variables:dataObject,
      context: {
        headers: {
          Authorization: `Bearer ${accesTokenValue}`,
        },
      },
    })
    .then((response) => {
      toaster.success("Receivable added successfully.")
      window.location.reload()
    })
    .catch((error) => {
      toaster.danger(error.message)
    });
  }



 
  
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    let va = value
      if(name==="amount"){
        va = parseFloat(value)
        let floatValue = va.toFixed(1);
        console.log("save as flit",typeof floatValue)
        va = parseFloat(floatValue)
        console.log("save as flit",typeof va)
        // va = 400.0
      }
      setDataObject({
        ...dataObject,
        [name]: va
      });
    
  };

const handleSelectionChange = (name='',option) => {
    console.log("name-===",name)
    console.log("value==",option)
    setDataObject({
      ...dataObject,
      [name]: option
    });
};


const handleBillSelect = (value) => {
  console.log(value)
  // setSelectedBank(value)
  // console.log(selectedBank)
  setDataObject({
    ...dataObject,
    appliesToBills:true,
    billIds: [value] 
  });
};

      return (
            <Pane>
              <Dialog
                isShown={isShown}
                title="Add Receivables"
                onCloseComplete={() => setIsShown(false)}
                hasHeader={true}
                shouldCloseOnOverlayClick={false}
                shouldCloseOnEscapePress={false}
                hasFooter ={false}
              >
                  
                 
                  <div className=''>
                  <div>
                  <form onSubmit={handleSubmit}>
                  {/* <form> */}
                      <div className='row'>
                              <div className='col s12 '>
                                  <InputFieldTitleText>
                                      Amount
                                  </InputFieldTitleText>
                                  <AppInputField
                                      type="number" step="0.01"
                                      placholder=""
                                      name="amount" // Change to the desired field name in the object
                                      onChange={handleInputChange}
                                  required/> 
                              </div>
                              
                              <div className='col s12 '>
                                  <InputFieldTitleText>
                                   Description
                                  </InputFieldTitleText>
                                  <AppInputField
                                      type="text" 
                                      placholder="Enter square meter"
                                      name="description" // Change to the desired field name in the object
                                      onChange={handleInputChange}
                                  required/> 
                              </div>
                              <div className='col s12 '>
                                <InputFieldTitleText>
                                Received Date
                                </InputFieldTitleText>
                                <AppInputField
                                    type="datetime-local" 
                                    name='receivedOn'
                                    placholder=""
                                    onChange={handleInputChange}
                                required/> 
                            </div>

                              <div className='col s12 '>
                                  <InputFieldTitleText>
                                  Received from
                                  </InputFieldTitleText>
                                  <div className='col s12'>
                                    <DropdownWidget
                                      title="Select type "
                                      options={['resident','owner']} 
                                      onSelectionChange={(option)=>handleSelectionChange('receivedFromType',option)}
                                    />
                                  </div>
                              </div>
                              <div className='col s12 '>
                                  <InputFieldTitleText>
                                  Receivable type
                                  </InputFieldTitleText>
                                  <div className='col s12'>
                                    <DropdownWidget2
                                      title="Non-bil Receivable"
                                      options={['Bill Receivable','Non-bil Receivable']} 
                                      onSelectionChange={(e)=>{
                                        console.log(e);
                                        if(e==='Bill Receivable'){
                                          setChecked(true)
                                          setDataObject({
                                            ...dataObject,
                                            appliesToBills:true
                                            }
                                          );
                                        }else {
                                          setChecked(false)
                                          setDataObject({
                                            ...dataObject,
                                            appliesToBills:false
                                            }
                                          );
                                        }
                                        
                                      }}
                                    />
                                  </div>
                                </div>
                              {checked &&
                                <div className='col s12 '>
                                    <InputFieldTitleText>
                                    Associated Bills
                                    </InputFieldTitleText>
                                    <SelectDue
                                      propertyId={property._id} 
                                      onSelect={handleBillSelect}
                                    />
                                </div>
                              }

                            
                              <div className='row'>
                                  <div className='col s12 right' style={{
                                      display:"flex",
                                      flexWrap:"wrap",
                                      justifyContent:"end"
                                  }}>
                                       <div className='' style={{
                                          width:"120px",
                                      }}>
                                         <AppInputFieldBtnCancel 
                                          className='btn btn-flat center p-2'
                                          style={{
                                              background:"transparent !important"
                                          }} 
                                          onClick={() => setIsShown(false)}
                                        >
                                              Cancel
                                          </AppInputFieldBtnCancel >
                                      </div>

                                    
                                      <div className='' style={{
                                          width:"120px",
                                      }}>
                                          {loading  &&
                                          <center>
                                              <Spinner/>
                                          </center>
                                          }
                                          {!loading &&
                                              <AppInputFieldBtn className=''
                                              type="submit"
                                              disabled={loading}
                                            >
                                                  Add
                                            </AppInputFieldBtn>
                                          }
                                          
                                    </div>
                                  </div>
                              </div>
                          <br/>
                      </div>
                      </form>
                  </div>
                  </div>
              </Dialog>
              <div className=''>
                  <FieldBtn 
                   onClick={() => setIsShown(true)}
                  class="waves-effect waves-light btn-flat ">
                      <i class="material-icons left">add</i>
                      Add Received Bill
                  </FieldBtn>
              </div>
      
            </Pane>
          )
  }
  

  export const FETCH_Bills = gql`
 query Bills_getByProperty($propertyId: ID!, $status: BillStatusInput!) {
  bills_getByProperty(propertyId: $propertyId, status: $status) {
    _id
    due
    property
    payerType
    amount
    title
    description
    isRecurring
    nextPaymentDate
    status
    paidOn
    paidBy
    paidByType
    createdAt
    id
  }
}
  `





